import { useMemo } from "react";
import { useSearchParams } from "react-router";

/**
 * Returns the URL to which a fan should be redirected after a successful login.
 *
 * If the URL is not specified in the query string, the default is `/games`.
 *
 * Note that the URL is validated to ensure it is a same-origin URL.
 */
export function useAfterLoginRedirectUrl() {
  const [searchParams] = useSearchParams();
  const redirectToParam = searchParams.get("redirectTo");

  // Validate the redirectTo parameter to ensure it is a same-origin URL.
  // If it is not valid, we will not use it and default to `/games`.
  // This is a security measure to prevent open redirects.
  const redirectToUrl =
    redirectToParam && isSameOrigin(redirectToParam, window.location.origin)
      ? redirectToParam
      : undefined;

  return useMemo(() => {
    return redirectToUrl ?? "/games";
  }, [redirectToUrl]);
}

function isSameOrigin(destination: string, currentOrigin: string): boolean {
  const url = new URL(destination, currentOrigin);

  return url.origin === currentOrigin;
}
